<template>
<el-dialog :title="msg('登录采购平台')" :visible.sync="visible" 
    :fullscreen="isMinScreen"
    :close-on-click-modal="false"
    append-to-body
    width="400px">
    <el-row>
        <el-col :xs="12" :sm="4">
            <el-link type="primary" href='https://login.taobao.com/member/login.jhtml' target="_blank">淘宝</el-link>
        </el-col> 
        <el-col :xs="12" :sm="4">
            <el-link type="primary" href='https://mobile.yangkeduo.com/login.html' target="_blank">拼多多</el-link>
        </el-col>
        <el-col :xs="12" :sm="4">
            <el-link type="primary" href='https://login.1688.com' target="_blank">1688</el-link>
        </el-col>
    </el-row>
    <div style="text-align:center; margin-top: 20px;">
        <el-button  size="mini" v-on:click="close">{{msg('关闭')}}</el-button>
    </div>  
</el-dialog>
</template>

<script>

export default {
    name: 'StockDetailPurchaseLogin',
    data(){
        return{
            visible: false,
        }
    }, 
    props: {
    },
    computed:{ 
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
                return this.$store.state.isMinScreen;
            }
        }
    },
    mounted: function(){
    },
    methods:{
        showDialog(){
            this.visible = true;
        },
        close(){
            this.visible = false;
            this.$emit('finish');
        }
    
    }
}
</script>

<style scoped lang="scss">

</style>
